export default "__VITE_ASSET__BhBP3_ej__"